import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FlyoutService {
  private isFlyoutOpenSubject = new BehaviorSubject<boolean>(false);
  public isFlyoutOpen$ = this.isFlyoutOpenSubject.asObservable();

  // FlyoutService
  openFlyout(): void {
    this.isFlyoutOpenSubject.next(true); // Ensure state is updated
  }

  closeFlyout(): void {
    this.isFlyoutOpenSubject.next(false); // Ensure state is updated
  }
}
